import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import { loginWithGoogle } from "../../../redux/slice/userSlice";

const GoogleLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tryGoogleLogin = async () => {
    try {
      await dispatch(loginWithGoogle()).unwrap();
      navigate("/client/home", { replace: true });
    } catch (err) {
      navigate("/login", { replace: true });
    }
  };

  useEffect(() => {
    tryGoogleLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Loading />
    </div>
  );
};

export default GoogleLogin;
